import React, { useState, useRef, useEffect,lazy, Suspense } from 'react';
import '../../../styles/profilepage.css';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { MdModeEdit } from 'react-icons/md';
import {
  IoSettingsOutline,
  IoToggleOutline,
  IoChevronDown,
} from 'react-icons/io5';
import { MdOutlineMonitor } from 'react-icons/md';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import profilelogo from '../../../assets/icons/logo.svg';
import logo from '../../../assets/icons/NewLogo.png';
import logoutIcon from '../../../assets/icons/logout.svg';
import TermsIcon from '../../../assets/icons/terms.svg';
import PrivacyIcon from '../../../assets/icons/privacy.svg';
import HelpIcon from '../../../assets/icons/help.svg';
import ArchiveIcon from '../../../assets/icons/archive.svg';
import CallIcon from "../../../assets/icons/calendlyicon.png";
import { PatientServices } from '../services/PatientServices';
import { AuthServices } from '../../auth/services/AuthServices';
import SlideOver from "../../home/components/SlideOver";
import OverlayHeader from "../../../shared/components/OverlayHeader";
import BottomUpModal from '../../../shared/components/BottomUpModal';
import { handleShare } from "./share";
import {  FaWhatsapp,
  FaFacebook, 
  FaLinkedinIn ,
  FaInstagram ,
  FaTelegram ,
  FaPinterest ,
  FaYahoo,
  FaShareAltSquare,
  FaReddit ,
  FaTumblrSquare ,
  FaSkype ,
  FaSnapchatSquare ,
  FaLink,

 } from "react-icons/fa";
 import { FaSquareXTwitter ,FaSquareThreads } from "react-icons/fa6";
 import { SiGmail } from "react-icons/si";
 import { PiMicrosoftOutlookLogoFill } from "react-icons/pi";
 import CalendlyModal from "../../../shared/utils/CalendlyModal"; 

export default function ProfilePanel({ onClose }) {
  const [theme, setTheme] = useState('System');
  const navigate = useNavigate();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [rating, setRating] = useState(5);
  const [feedbackText, setFeedbackText] = useState('');
  const [isEditingName, setIsEditingName] = useState(false);
  const [profilePictureHost, setProfilePictureHost] = useState('');
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser
      ? JSON.parse(storedUser)
      : { email: '', user_id: '', first_name: '', last_name:'',profile_picture: '' };
  });

  const [basicuser, setBasicuser] = useState(() => {
    const baseUser = localStorage.getItem('basic-user');
    return baseUser
      ? JSON.parse(baseUser)
      : { email: '', user_id: '', first_name: '', last_name:'',profile_picture: '' };
  });

  const [editedName, setEditedName] = useState(user.first_name+' '+user.last_name || '');
  const fileInputRef = useRef(null);
  const [showTermsModal, setShowTermsModal] = useState(false);   // ✅ add this
  const [showPrivacyModal, setShowPrivacyModal] = useState(false); // ✅ add this
  const [showCalendlyModal, setShowCalendlyModal] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const [showShareModal,setshowShareModal] = useState(false);
  const [showModal,setShowModal] = useState(false);
  

    const [panel, setPanel] = useState(null);
    const openPanel = (key) => setPanel(String(key).toLowerCase());
    const closePanel = () => setPanel(null);

    const HelpPanel = lazy(() => import("../pages/HelpPage"));
    const ArchivePanel = lazy(() => import("../pages/ArchivedSessions"));
    const contentRef = useRef(null);

const scrollToBottom = () => {
  const el = document.querySelector(".profile-content");
  if (el) {
    el.scrollTo({
      top: el.scrollHeight,
      behavior: "smooth",
    });
  }
};

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setShowModal("Uploading your profile picture");
    const formData = new FormData();
    formData.append('profilePhoto', file, user.id + file.name);

    const response = await PatientServices.updatePhoto(formData);

    if (response.status !== 200) {
      console.log('There was an error uploading your image. Please try again.');
      return;
    }

    const updatedUser = {
      ...user,
      profile_picture: response?.data?.data?.imageUrl,
    };
    setUser(updatedUser);
    setShowModal(false);
  };

  const handleNameSave = () => {
    const updatedUser = { ...user, name: editedName };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    PatientServices.UpdateUserName(updatedUser);
    setIsEditingName(false);
  };

  const handlefeedback = () => {
    setShowFeedbackModal(true);
  };

  
const handleLogout = async () => {
  setIsLogout(true);
  setCountdown(3); // reset timer

  try {
    const response = await AuthServices.logout();
    if (response.status !== 200) {
      console.error('Logout failed, please try again.');
    }
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          localStorage.clear();
          navigate("/login");
        }
        return prev - 1;
      });
    }, 1000);
  }
};

  const handleSubmitFeedback = async (rating, feedbackText) => {
    const feedback = { rating, text: feedbackText };
    try {
      const response = await PatientServices.submitFeedback(
        rating,
        feedbackText
      );
      if (response.status !== 200) {
        console.error('Failed to submit feedback:', response);
        return;
      }
      //navigate('/login');
      setSubmitted(true); // Show thank you message
      /*setShowFeedbackModal(false)
      setFeedbackText("");
      setRating(5);
      handleLogout();*/
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  // const fetchUserData = async () => {
  //   const response = await AuthServices.fetchUserData();
  //   console.log(response);
  // };

  const fetchUserData = async () => {
    const response = await AuthServices.fetchUserData();
    if (response?.data) {
      const apiUser = response.data;
      const normalizedUser = {
        ...apiUser,
        name: apiUser.name || `${apiUser.first_name || ""} ${apiUser.last_name || ""}`.trim(),
      };
      setUser(normalizedUser);
      localStorage.setItem("user", JSON.stringify(normalizedUser));
    }
  };

  const handleBack = () => navigate(-1);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  useEffect(() => {
    if (user?.profile_picture) {
      const url = `${user?.profile_picture.split('images/')[1]}`;
      setProfilePictureHost(url);
    }
  }, [user]);

  useEffect(() => {
    if (!localStorage.getItem('user')) {
      fetchUserData();
    }
  }, []);



  useEffect(() => {
    if (showFeedbackModal) {
      setRating(5);
    }
  }, [showFeedbackModal]);

  // make body scrollable on desktop, keep hidden on mobile
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1023px)");
    const apply = () => {
      document.body.style.overflow = mq.matches ? "hidden" : "auto";
    };
    apply();
    mq.addEventListener("change", apply);
    return () => {
      mq.removeEventListener("change", apply);
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (

    <div className="profile-container">
          <OverlayHeader onBack={onClose}  style={{height:"135px"}}/>
   { /*</div><div className="profile-container">
      <div className="flat-header">
        <button className="back-button" onClick={handleBack}>
          <IoIosArrowBack size={18} />
        </button>
        <img src={logo} alt="PrashaSync Logo" className="archived-logo" />
      </div>*/}

       <SlideOver title={panel === "help" ? "Help" :  panel === "archive" ? "Archive" :""} isOpen={!!panel} onClose={closePanel}
       width="100vw"
       >
                    {panel && (
                      <Suspense fallback={<div>Loading…</div>}>
                        {panel === "help" && <HelpPanel onClose={closePanel} />}
                        {panel === "archive" && <ArchivePanel onClose={closePanel} />}
                      </Suspense>
                    )}
                  </SlideOver>

      <div
        className="profile-image-wrapper"
        onClick={() => fileInputRef.current.click()}
      >
        <img
          src={
            user?.profile_picture?.trim()
              ? `${process.env.REACT_APP_IMAGE_UPLOAD_FOLDER}/${profilePictureHost}`
              : basicuser?.profile_picture?.trim() ? basicuser?.profile_picture
              : profilelogo
          }
          alt="Profile"
          className="profile-image"
          style={{
            filter: user?.photo?.trim(),
          }}
        />
        <div className="edit-icon-avatar">
          <MdModeEdit size={16} />
        </div>
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleImageUpload}
        />
      </div>

      <div className="profile-content">
        <div className="name-row">
          {/* <h2 className="name">
            {user?.first_name + ' ' + user.last_name || (
              <span className="placeholder-text">Enter your name</span>
            )}
          </h2> */}
          <h2 className="name">
            {user?.name?.trim() ||
              `${user?.first_name || ""} ${user?.last_name || ""}`.trim() ||
              `${basicuser?.first_name || ""} ${basicuser?.last_name || ""}`.trim() ||
              
              <span className="placeholder-text">Enter your name</span>}
          </h2>
          <div
            className="edit-icon-name"
            onClick={() => setIsEditingName(true)}
          >
            <MdModeEdit size={16} />
          </div>
        </div>
        <p className="email">{user.email}</p>

        <div className="appearance-box">
          <div className="appearance-label">
            <IoToggleOutline size={20} />
            <span>Appearance</span>
          </div>
          <div className="appearance-dropdown">
            <MdOutlineMonitor size={18} />
            <select
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
              className="custom-select"
            >
              <option className="custom-select" value="System">System</option>
              <option className="custom-select" value="Light" disabled>Light</option>
              <option className="custom-select"value="Dark" disabled>Dark</option>
            </select>
            <IoChevronDown size={16} />
          </div>
        </div>

        {/* Settings */}
        <div className="settings-box">
          <div className="settings-title">
            <IoSettingsOutline size={16} />
            <span>Settings</span>
          </div>

          <div
            className="setting-item"
            onClick={() => setShowTermsModal(true)}
          // onClick={() =>
          //   window.open(
          //     'https://prashauploadimages.blob.core.windows.net/docs/PraSha%20Sync%20terms%20of%20use.pdf',
          //     '_blank'
          //   )
          // }
          >
            <div className="setting-left">
              <img src={TermsIcon} alt="Terms" className="setting-icon" />
              <span>Terms of Use</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          <div
            className="setting-item"
            onClick={() => setShowPrivacyModal(true)}
          // onClick={() =>
          //   window.open(
          //     'https://prashauploadimages.blob.core.windows.net/docs/PraShaSync%20privacy%20policy.pdf',
          //     '_blank'
          //   )
          // }
          >
            <div className="setting-left">
              <img src={PrivacyIcon} alt="Privacy" className="setting-icon" />
              <span>Privacy Policy</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          {/*<div className="setting-item" onClick={() => navigate('/archive')}>*/}
          <div className="setting-item" onClick={() => openPanel("archive")}>
            <div className="setting-left">
              <img src={ArchiveIcon} alt="Archive" className="setting-icon" />
              <span>Archive</span>
            </div>
            <IoIosArrowForward size={18} />
          </div>

          {/*<div className="setting-item" onClick={() => navigate('/help')}>*/}
            <div className="setting-item" onClick={() => openPanel("help")}>
            <div className="setting-left">
              <img src={HelpIcon} alt="Help" className="setting-icon" />
              <span>Help</span>
            </div>
            <IoIosArrowForward size={18} />
          </div>
        </div>

        {/* Support & Share (separate box) */}
        <div className="settings-box">
          <div className="settings-title">
            <IoSettingsOutline size={16} />
            <span>Support & Share</span>
          </div>

          <div
            className="setting-item"
            onClick={() => window.open('https://findahelpline.com', '_blank')}
          >
            <div className="setting-left">
              <img src={HelpIcon} alt="Helpline" className="setting-icon" />
              <span>Find a helpline</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          <div
            className="setting-item"
            onClick={() => 
              {
                  scrollToBottom();
                  setShowCalendlyModal(true);
              }
            
            }
          >
            <div className="setting-left">
              <img src={CallIcon} alt="Book a call" className="setting-icon" />
              <span>Connect to founder</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          <div
            className="setting-item"
            onClick={() => 
              {
                  scrollToBottom();
                  setShowFeedbackModal(true);
              }
            }
          >
            <div className="setting-left">
              <img src={HelpIcon} alt="Book a call" className="setting-icon" />
              <span>User feedback</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          <div className="setting-item" 
          onClick={() => {
            scrollToBottom();
            setshowShareModal(true);
         }}
          >
            <div className="setting-left">
              <img src={TermsIcon} alt="Share" className="setting-icon" />
              <span>Share PraSha Sync</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-box-arrow-up"
              viewBox="0 0 16 16"
            >
              <path fillRule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z" />
              <path fillRule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708z" />
            </svg>
          </div>
        </div>

        {/* Logout */}
        <div className="settings-box" style={{border:"0px solid #fff"}}>
          <button className="logout-button" onClick={handleLogout}>
            Log out <img src={logoutIcon} alt="Logout" className="logout-icon" />
          </button>
        </div>

       

      </div>


       {showTermsModal && (
        <div className="bottomSlide-modal-overlay"  onClick={() => setShowTermsModal(false)}>
          <div className="bottomSlide-modal" style={{height:"75vh"}} onClick={(e) => e.stopPropagation()}>

             <button
        className="bottomSlide-close-btn"
        aria-label="Close modal"
        onClick={() => setShowTermsModal(false)}
      >
        ×
      </button>

            <div className="modal-header-login">
              <h3>Terms & Conditions</h3>
              
            </div>
            <hr style={{ marginBottom: "20px" }} />
            
            <iframe
              src="/docs/PraSha-Sync-terms-of-use.html"
              title="Terms of Use"
              className="doc-frame"
              style={{height:"75%"}}

              ref={(el) => {
          if (el) {
            // Auto-scroll iframe content
            el.onload = () => {
              const iframeWindow = el.contentWindow;
              const iframeDoc = el.contentDocument || iframeWindow.document;
              const body = iframeDoc.body;

              let scrollStep = 1; // 1px per frame
              function autoScroll() {
                iframeWindow.scrollBy(0, scrollStep);
                if (
                  iframeWindow.scrollY + iframeWindow.innerHeight >=
                  body.scrollHeight
                ) {
                  //iframeWindow.scrollTo(0, 0); // reset to top
                }
                requestAnimationFrame(autoScroll);
              }

              setTimeout(() => {
          autoScroll();
        }, 2000);
            };
          }
        }}

              
            />
            {
              <button className="modal-close-btnlogin" style={{display:"none" }} onClick={() => setShowTermsModal(false)}>
                Close
              </button>
            }
          </div>
        </div>
      )}


      {/* Privacy Modal */}
       {showPrivacyModal && (
  <div
    className="bottomSlide-modal-overlay"
    onClick={() => setShowPrivacyModal(false)}
  >
    <div
      className="bottomSlide-modal" style={{height:"75vh"}}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close-xlogin"
        aria-label="Close modal"
        onClick={() => setShowPrivacyModal(false)}
      >
        ×
      </button>

      <div className="modal-header-login">
        <h3>PraSha Sync - Privacy Policy</h3>
      </div>
      <hr style={{ marginBottom: "20px" }} />

      <iframe
        src="/docs/PraSha-Sync-Privacy-Policy.html"
        title="Privacy Policy"
        className="doc-frame"
        style={{height:"75%"}}

        ref={(el) => {
          if (el) {
            // Auto-scroll iframe content
            el.onload = () => {
              const iframeWindow = el.contentWindow;
              const iframeDoc = el.contentDocument || iframeWindow.document;
              const body = iframeDoc.body;

              let scrollStep = 1; // 1px per frame
              function autoScroll() {
                iframeWindow.scrollBy(0, scrollStep);
                if (
                  iframeWindow.scrollY + iframeWindow.innerHeight >=
                  body.scrollHeight
                ) {
                  //iframeWindow.scrollTo(0, 0); // reset to top
                }
                requestAnimationFrame(autoScroll);
              }

              setTimeout(() => {
          autoScroll();
        }, 2000);
            };
          }
        }}

      />

      <button
        className="modal-close-btnlogin"
        style={{display:"none"}}
        onClick={() => setShowPrivacyModal(false)}
      >
        Close
      </button>
    </div>
  </div>
)}


         
      

{showCalendlyModal && (
  <div
    className="bottomSlide-modal-overlay"
    style={{backgroundColor:"E9EEFF"}}
    onClick={() => setShowCalendlyModal(false)}
  >
    <div
      className="calendly-modal" style={{backgroundColor:"E9EEFF", important:true}}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close-xlogin"
        aria-label="Close modal"
        onClick={() => setShowCalendlyModal(false)}
      >
        ×
      </button>

      <div className="modal-header-login">
        <h3>Book a Session</h3>
      </div>
      

        <CalendlyModal
          
          prefill={{ name: "Nasim Akhter Mondal" }}
          
        />
        {/*
      <iframe
        src="https://calendly.com/nasim-x-mondal/30min?background_color=#E9EEFF"
        title="Book a Call"
        className="doc-frame" 
        style={{height:"75%", background:"transparent"}}
        allowTransparency="true"
      />
*/}
      <button
        className="modal-close-btnlogin"
        style={{display:"none" }}
        onClick={() => setShowCalendlyModal(false)}
      >
        Close
      </button>
    </div>
  </div>
)}




{/* Share Modal */}
{showShareModal && (
  <div
    className="bottomSlide-modal-overlay"
    onClick={() => setshowShareModal(false)}
  >
    <div
      className="bottomSlide-modal"
      
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close-xlogin"
        aria-label="Close modal"
        onClick={() => setshowShareModal(false)}
      >
        ×
      </button>

      <div className="modal-header-login">
        <h3 style={{ textAlign: "center", marginBottom: "15px" }}>
          Share PraSha Sync
        </h3>
      </div>
      <hr style={{ marginBottom: "20px" }} />

      <div
        className="share-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
          gap: "25px",
          justifyItems: "center",
          alignItems: "center",
          flex: 1,
          overflowY: "auto",
          padding: "10px",
          background: "transparent",
        }}
      >
        {[
          { channel: "copy", icon: <FaLink size={40} color="gray" />, label: "Copy URL"},
          { channel: "whatsapp", icon: <FaWhatsapp size={40} color="#25D366" />, label: "WhatsApp" },
          { channel: "gmail", icon: <SiGmail size={40} color="#EA4335" />, label: "Gmail" },
          { channel: "yahoo", icon: <FaYahoo size={40} color="#720E9E" />, label: "Yahoo" },
          { channel: "outlook", icon: <PiMicrosoftOutlookLogoFill size={40} color="#0072C6" />, label: "Outlook" },
          { channel: "instagram", icon: <FaInstagram size={40} color="#E1306C" />, label: "Instagram" },
          { channel: "facebook", icon: <FaFacebook size={40} color="#1877F2" />, label: "Facebook" },
          { channel: "linkedin", icon: <FaLinkedinIn size={40} color="#0A66C2" />, label: "LinkedIn" },
          { channel: "twitter", icon: <FaSquareXTwitter size={40} color="black" />, label: "Twitter" },
          { channel: "telegram", icon: <FaTelegram size={40} color="#0088cc" />, label: "Telegram" },
          { channel: "pinterest", icon: <FaPinterest size={40} color="#E60023" />, label: "Pinterest" },
          { channel: "reddit", icon: <FaReddit size={40} color="#FF4500" />, label: "Reddit" },
          { channel: "tumblr", icon: <FaTumblrSquare size={40} color="#35465C" />, label: "Tumblr" },
          { channel: "skype", icon: <FaSkype size={40} color="#00AFF0" />, label: "Skype" },
          { channel: "snapchat", icon: <FaSnapchatSquare size={40} color="#FFFC00" />, label: "Snapchat" },
          { channel: "threads", icon: <FaSquareThreads size={40} color="black" />, label: "Threads" },
          { channel: "system", icon: <FaShareAltSquare size={40} color="gray" />, label: "System" },
        ].map(({ channel, icon, label }) => (
          <button
            key={channel}
            onClick={() => handleShare({ channel })}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "50%",
                padding: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                transition: "transform 0.2s",
              }}
              className="icon-button"
            >
              {icon}
            </div>
            <span style={{ fontSize: "12px", color: "#555" }}>{label}</span>
          </button>
        ))}
      </div>

      <button
        className="modal-close-btnlogin"
        style={{ marginTop: "20px",display:"none" }}
        
        onClick={() => setshowShareModal(false)}
      >
        Close
      </button>
    </div>
  </div>
)}

     

{/*//----------------------------------------------------*/}
{isLogout && (
  <div className="logout-overlay">
    <div className="logout-modal">
      <img
        src={logo}
        alt="Prashasync Logo"
        className="modal-logo-google"
      />
      <h3>Thank you for today's session</h3>
      <p>
        Have a great {new Date().getHours() < 17 ? "day" : "evening"} — see you soon!
      </p>
      <p style={{ marginTop: "15px", fontWeight: "bold" }}>
        Logging out in {countdown}...
      </p>
    </div>
  </div>
)}


      {isEditingName && (
        <div className="edit-name-modal">
          <div className="modal-content">
            <div className="modal-bar"></div>
            <h4>Edit your name</h4>
            <input
              type="text"
              className="name-input"
              placeholder="Ex. John Mathew"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
            />
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setIsEditingName(false)}
              >
                Cancel
              </button>
              <button
                className="done-btn"
                onClick={handleNameSave}
                disabled={!editedName.trim()}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      
      
      
      {/* Feedback Modal */}
      {showFeedbackModal && (
  <div
    className="bottomSlide-modal-overlay"
    onClick={() => {
       setShowFeedbackModal(false);
    }}
  >
    <div className="bottomSlide-modal" onClick={(e) => e.stopPropagation()}>
      <button
        className="bottomSlide-close-btn"
        onClick={() => {
          setShowFeedbackModal(false);
        }}
      >
        ✖
      </button>

      {submitted ? (
        <div className="thank-you-message">
          <h3 style={{ fontSize: '18px', color: '#000' }}>
            Thank you for your feedback!
          </h3>
          {/*<p>You will be logged out shortly.</p>*/}
        </div>
      ) : (
        <>
          <div className="emoji">
            {['🤔', '😞', '😐', '😐', '😄', '😍'][rating - 1] || '🤔'}
          </div>

          <div className="stars-row">
            {[1, 2, 3, 4, 5].map((val) => (
              <span
                key={val}
                className={`star ${val <= rating ? 'filled' : ''}`}
                onClick={() => setRating(val)}
              >
                ★
              </span>
            ))}
          </div>

          <h3>Tell Us</h3>
          <p>
            {rating >= 4
              ? 'We’re thrilled to hear that!'
              : rating > 0
              ? 'We’re sorry the experience didn’t meet your expectations.'
              : 'How was your experience?'}
          </p>
          <p className="prompt">
            {rating >= 4
              ? 'What did you enjoy the most, and is there anything we can do to make your experience even better?'
              : rating > 0
              ? 'Could you share what specifically didn’t work for you, and how we can do better next time?'
              : 'Tap a star and share your thoughts!'}
          </p>

          <textarea
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder="Type here..."
            maxLength={500}
          />
          <div className="char-count">{feedbackText.length}/500</div>

          <button
            className="submit-btn"
            disabled={rating === 0}
            onClick={async () => {
              try {
                await handleSubmitFeedback(rating, feedbackText);
                setSubmitted(true); // show thank-you message
              } catch (error) {
                console.error("Error submitting feedback:", error);
              }
            }}
          >
            Submit
          </button>
        </>
      )}
    </div>
  </div>
)}


{showModal && (

<div className="feedback-modal-overlay">
        <div className="feedback-modal">
      <img
        src={logo}
        alt="Prashasync Logo"
        className="modal-logo-google"
      />
      <h3>Please wait… </h3>
      <p>{showModal} </p>
    </div>
  </div>

  
)}



{/* Terms Modal */}
{/*<BottomUpModal
  show={showTermsModal}
  onClose={() => setShowTermsModal(false)}
  title="PraSha Sync - Terms of Use"
>
  <iframe
    src="/docs/PraSha-Sync-terms-of-use.html"
    title="Terms of Use"
    style={{ width: "100%", height: "100%", border: "none" }}
  />
</BottomUpModal>
*/}


{/* Privacy Policy */}
{/*<BottomUpModal
  show={showPrivacyModal}
  onClose={() => setShowPrivacyModal(false)}
  title="PraSha Sync - Privacy Policy"
  autoScroll={true}   // ✨ enable auto scroll
  autoScrollSpeed={2}
>
  <iframe
    src="/docs/PraSha-Sync-Privacy-Policy.html"
    title="Privacy Policy"
    style={{ width: "100%", height: "100%", border: "none" }}
  />
</BottomUpModal>
*/}

    </div>
  );


}

